/* LUMERIX Firmengeschenke: sanftes Einblenden und mobiler Sticky-CTA */
(function () {
  if (window.__lxBusiness) return;
  window.__lxBusiness = true;

  function init() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = document.querySelectorAll('.lxb [data-lx-reveal]');

    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      items.forEach(function (el) { io.observe(el); });
    }

    // Links mit data-lx-preselect waehlen im Ziel-Formular eine Option vor (z. B. "Eine andere Idee")
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-lx-preselect]');
      if (!link) return;
      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;
      var wanted = link.getAttribute('data-lx-preselect');
      target.querySelectorAll('select').forEach(function (select) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === wanted) select.selectedIndex = i;
        }
      });
    });

    // Sticky-CTA: erscheint, sobald der Hero-Button aus dem Bild ist, und verschwindet beim Formular
    var sticky = document.querySelector('[data-lx-sticky]');
    var heroCta = document.querySelector('[data-lx-hero-cta]');
    var form = document.getElementById('anfrage');
    if (!sticky || !heroCta || !('IntersectionObserver' in window)) return;

    var heroGone = false;
    var formVisible = false;
    function update() { sticky.classList.toggle('is-visible', heroGone && !formVisible); }

    new IntersectionObserver(function (e) { heroGone = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; update(); }).observe(heroCta);
    if (form) new IntersectionObserver(function (e) { formVisible = e[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(form);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
